/*
 *
 * Summary constants
 *
 */

import { Disciplines } from '../../domain';

export const SLICE_NAME = 'summary';

export const HAS_NO_RESULTS_DISCIPLINES = [
  Disciplines.BoxOffice,
  Disciplines.ArenaCourseHire,
  Disciplines.XCCourseHire,
  Disciplines.TrainingClinics,
];

export const HAS_NO_TIMES_DISCIPLINES = [
  Disciplines.BoxOffice,
  Disciplines.ArenaCourseHire,
  Disciplines.XCCourseHire,
];
